import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PrescriptorRoutingService } from "../../../services/prescriptor-routing.service";

@Component({
    selector: "prescp-oauth-callback",
    template: ""
})
export class OAuthCallbackComponent implements OnInit {

  constructor(
    private readonly router: Router,
    private readonly prescriptorRoutingService: PrescriptorRoutingService
  ) {}

  ngOnInit(): void {
    // OAuthGuard guarantees token exists when this component activates.
    // No need for event subscription — the guard is the wait mechanism.
    this.prescriptorRoutingService.getDatosPrescriptorAndNavigate();
  }
}
